import { string, object } from 'yup';

export const schema = object().shape({
  creator_passenger: string().email('invalidEmailAddress'),
  assigned_passenger: string().email('invalidEmailAddress')
});